import { BaseService } from "../baseService";
import { EuRelabelCheckInAPIService } from "./euRelabelCheckInAPIService";
import { sanitiseParams } from "src/utils";
import { EuRelabelCheckIn, RelabelQuantityChangeReason, RelabelCaseRoutingType } from "src/types";
import { PostEuRelabelCheckInRequestBody } from "src/types/api/euRelabelCheckIns/postEuRelabelCheckIn";
import { PostTransferOrderEuRelabelCheckInRequestBody } from "src/types/api/euRelabelCheckIns/postTransferOrderEuRelabelCheckIn";

class EuRelabelCheckInService extends BaseService<EuRelabelCheckInAPIService> {
  @sanitiseParams()
  async createEuRelabelCheckIn(requestBody: PostEuRelabelCheckInRequestBody): Promise<EuRelabelCheckIn> {
    return await this.apiService.postEuRelabelCheckIn(requestBody);
  }

  @sanitiseParams()
  async getAllByPurchaseOrderId(purchaseOrderId: string): Promise<EuRelabelCheckIn[]> {
    return await this.apiService.getAllEuRelabelCheckInsByPurchaseOrderId(purchaseOrderId);
  }

  @sanitiseParams()
  async updateProductTotalQuantity(input: {
    purchaseOrderId: string;
    productId: string;
    routingType: RelabelCaseRoutingType;
    newTotalQuantity: number;
    reason: RelabelQuantityChangeReason;
    reasonNote?: string;
  }): Promise<EuRelabelCheckIn[]> {
    return await this.apiService.patchEuRelabelCheckInProductQuantity(input);
  }

  @sanitiseParams()
  async createTransferOrderEuRelabelCheckIn(
    requestBody: PostTransferOrderEuRelabelCheckInRequestBody
  ): Promise<EuRelabelCheckIn> {
    return await this.apiService.postTransferOrderEuRelabelCheckIn(requestBody);
  }

  @sanitiseParams()
  async getAllByTransferOrderId(transferOrderId: string): Promise<EuRelabelCheckIn[]> {
    return await this.apiService.getAllEuRelabelCheckInsByTransferOrderId(transferOrderId);
  }
}

export { EuRelabelCheckInService };
